import React, { Component } from 'react'
import classnames from 'classnames'
import { Grid, Col, Row } from 'react-flexbox-grid'
import { Colors } from '../../theme'
import Columns from '../../styles/columns'
import CardStyles from '../../styles/cards'
import ButtonStyles from '../../styles/buttons'
import Card from '@material-ui/core/Card'
import Icon from '@material-ui/core/Icon'
import { withStyles } from '@material-ui/core/styles'
import FilterDropdownMenu from '../../controls/FilterDropdownMenu'
import RBDatePicker from '../../controls/RBDatePicker'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { fetchClaims, changePage, storeFilters } from '../../redux/actions/claimsActions'
import moment from 'moment'
import { localize } from '../../util/Localizer'
import RBButton from '../../controls/RBButton'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'

class Filter extends Component {
  constructor () {
    super()
    this.updateFilters = this.updateFilters.bind(this)
    this.filterClaims = this.filterClaims.bind(this)
    this.applyFilters = this.applyFilters.bind(this)
    this.clearFilters = this.clearFilters.bind(this)
    this.showFilterBar = this.showFilterBar.bind(this)
    this.rememberFilters = this.rememberFilters.bind(this)
    this.getReceipts = this.getReceipts.bind(this)
    this.state = {
      collapseFilterBar: false,
      filters: {
        members: 0,
        benefit: 0,
        status: 0,
        startPeriod: null,
        endPeriod: null,
        onlyReceipts: false
      }
    }
  }

  componentDidMount () {
    this.rememberFilters()
  }

  updateFilters (valueObj) {
    const filters = this.state.filters
    const updatedFilters = Object.assign(filters, valueObj)
    this.setState({
      filters: updatedFilters
    })
  }

  rememberFilters () {
    if (this.props.filterObj) {
      this.setState({ filters: { ...this.props.filterObj } }, () => { return this.state.filters })
    }
  }

  applyFilters (nextFilters = {}) {
    this.setState({ filters: nextFilters })
    this.props.storeFilters(nextFilters)
    this.props.changePage(1)
    this.props.fetchClaims(nextFilters, 1, this.props.pageSize)
  }

  clearFilters () {
    this.membersDropdown.resetState()
    this.benefitsDropdown.resetState()
    this.statusDropdown.resetState()
    this.applyFilters({ ...this.props.defaultFilterObj })
  }

  filterClaims () {
    const filterCard = document.getElementById('filterCard')
    if (filterCard.classList.contains('showFilter')) {
      this.setState({ collapseFilterBar: !this.state.collapseFilterBar })
      filterCard.classList.toggle('showFilter')
    }

    this.applyFilters(this.state.filters)
  }

  showFilterBar () {
    this.setState({ collapseFilterBar: !this.state.collapseFilterBar })
    const filterCard = document.getElementById('filterCard')
    filterCard.classList.toggle('showFilter')
  }

  getReceipts (e, v) {
    const filters = Object.assign({}, this.state.filters, { onlyReceipts: v })
    this.setState({ filters: filters }, () => this.filterClaims())
  }
  prepareForDropdown (data) {
    return data
      .filter((item) => item.id !== 0)
      .map(item => ({ id: item.id, text: item.label }))
  }

  render () {
    const disableFilters = !((this.props.claims && this.props.claims.length) > 0)

    // TODO: Data should be mapped in componentWillReceiveProps to improve performance
    const members = this.props.filters ? this.prepareForDropdown(this.props.filters.patient) : []
    const benefits = this.props.filters ? this.prepareForDropdown(this.props.filters.benefits) : []
    const status = this.props.filters ? this.prepareForDropdown(this.props.filters.statuses) : []

    const dateInputProps = {
      style: {
        fontSize: '0.77rem',
        lineHeight: '1.1875rem',
        height: '1.9rem'// for ie's sake
      }
    }

    const { classes = {} } = this.props
    return (
      <div id={'filterComponent'}>
        <Card id='smallFilterCard' className={classes.baseCard}>
          <Row end='xs'>
            <Col>
              <RBButton
                label={localize('pages.claims.filter.filterClaims')}
                labelPosition='before'
                color
                iconRight={<Icon color='primary'>filter_list</Icon>}
                onClick={this.showFilterBar} />
            </Col>
          </Row>
        </Card>
        <Card id='filterCard' className={classes.baseCard}>
          <Grid fluid>
            <Row className='filterBar'>
              <Col lg={10} lgOffset={1} className='filterControls'>
                <Row style={{ display: 'flex', alignItems: 'baseline' }}>
                  <Col {...Columns.max6} className='ieFilterCard'>
                    <FilterDropdownMenu ref={(comp) => { this.membersDropdown = comp }}
                      fullWidth
                      data={members}
                      id='members'
                      defaultText={localize('pages.claims.filter.members.placeholder')}
                      label={localize('pages.claims.filter.members.label')}
                      sendValues={this.updateFilters}
                      disabled={this.props.isLoading || disableFilters}
                      selected={this.state.filters.members} />
                  </Col>
                  <Col {...Columns.max6} className='ieFilterCard'>
                    <FilterDropdownMenu ref={(comp) => { this.benefitsDropdown = comp }}
                      fullWidth
                      data={benefits}
                      id='benefit'
                      defaultText={localize('pages.claims.filter.benefits.placeholder')}
                      label={localize('pages.claims.filter.benefits.label')}
                      sendValues={this.updateFilters}
                      disabled={this.props.isLoading || disableFilters}
                      selected={this.state.filters.benefit} />
                  </Col>
                  <Col {...Columns.max6} className='ieFilterCard'>
                    <FilterDropdownMenu
                      ref={(comp) => { this.statusDropdown = comp }}
                      fullWidth
                      data={status}
                      id='status'
                      defaultText={localize('pages.claims.filter.status.placeholder')}
                      label={localize('pages.claims.filter.status.label')}
                      disabled={this.props.isLoading || disableFilters}
                      selected={this.state.filters.status}
                      sendValues={this.updateFilters} />
                  </Col>
                  <Col {...Columns.max6} className='ieFilterCard' >
                    <RBDatePicker ref={(comp) => { this.startDatepicker = comp }}
                      id='startPeriod'
                      label={localize('pages.claims.filter.startPeriod.label')}
                      fullWidth
                      pickerProps={{
                        InputProps: dateInputProps,
                        autoOk: true,
                        maxDate: this.state.filters.endPeriod || moment(),
                        disabled: this.props.isLoading || disableFilters,
                        value: this.state.filters.startPeriod,
                        onChange: (startPeriod) => this.updateFilters({ startPeriod: moment(startPeriod).startOf('day').format() })
                      }}
                    />
                  </Col>
                  <Col {...Columns.max6} className='ieFilterCard' >
                    <RBDatePicker ref={(comp) => { this.endDatepicker = comp }}
                      id='endPeriod'
                      label={localize('pages.claims.filter.endPeriod.label')}
                      fullWidth
                      pickerProps={{
                        InputProps: dateInputProps,
                        autoOk: true,
                        minDate: this.state.filters.startPeriod,
                        maxDate: moment(),
                        disabled: this.props.isLoading || disableFilters,
                        value: this.state.filters.endPeriod,
                        onChange: (endPeriod) => this.updateFilters({ endPeriod: moment(endPeriod).endOf('day').format() })
                      }}
                    />
                  </Col>
                  <Col {...Columns.max6} className='ieFilterCard'>
                    <Row center='xs'>
                      <Col>
                        <div className='applyFilterContainer'>
                          <RBButton id='applyFilter'
                            label={localize('pages.claims.filter.apply')}
                            onClick={this.filterClaims}
                            labelColor={Colors.primaryColor}
                            disabled={this.props.isLoading || disableFilters}
                            variant='outlined' color />
                        </div>
                        <Row center='xs' end='sm'>
                          <Col>
                            <RBButton
                              role='button'
                              className={ classnames(classes.linkButton, classes.clearFilterButton) }
                              color
                              label={localize('pages.claims.filter.clear')}
                              aria-label={localize('pages.claims.filter.clear')}
                              onClick={this.clearFilters}
                              labelStyle={{ color: Colors.Palette.primaryColor }}
                              disabled={this.props.isLoading || disableFilters}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                  </Col>
                </Row>
                <Row>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.filters.onlyReceipts}
                        onChange={this.getReceipts}
                        value={'true'}
                        color="primary"
                      />
                    }
                    label={localize('pages.claims.filter.showReceipt')}
                  />
                </Row>
              </Col>
            </Row>
          </Grid>
        </Card>

      </div>
    )
  }
}
function mapStateToProps (state, ownProps) {
  return {
    claims: state.ClaimsReducer.claims,
    error: state.ClaimsReducer.error,
    isLoading: state.ClaimsReducer.isLoading,
    allClaims: state.ClaimsReducer.allClaims,
    filters: state.ClaimsReducer.filters,
    filterObj: state.ClaimsReducer.filterObj,
    defaultFilterObj: state.ClaimsReducer.defaultFilterObj,
    pageNum: state.ClaimsReducer.pageNum,
    pageSize: state.ClaimsReducer.pageSize
  }
}

const ConnectedFilter = connect(mapStateToProps, { fetchClaims, changePage, storeFilters }, null, { withRef: true })(injectIntl(Filter, { withRef: true }))

const styles = {
  ...CardStyles,
  ...ButtonStyles,
  clearFilterButton: {
    marginTop: '-5px !important',
    marginRight: '-5px !important',
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '&:disabled': {
      color: Colors.Palette.disabledTextColor
    }
  }
}

export default withStyles(styles)(ConnectedFilter)



// WEBPACK FOOTER //
// ./src/widgets/Claims/Filter.js